// extracted by mini-css-extract-plugin
export default {"typewriter":"Typewriter_typewriter__2ecLB","cursor":"Typewriter_cursor__F+aZZ","blink":"Typewriter_blink__iV6Xc"};